import React from "react";
import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';

import { useNavigate } from "react-router-dom";

import Service from "../../../util/Service";


export default function VerticalMenuPageSolicitacoes(props) {
    const { menu } = props;
    const [open, setOpen] = React.useState(false);
    const [solicitacoes, setSolicitacoes] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (menu) {
            Service.GET(menu.api).then(r =>
                setSolicitacoes(r)
            );
        }
    }, [menu])


    const handleClickForm = (serv) => {
        console.log(serv);
        navigate('/form/' + serv.id);
    }

    return (
        <React.Fragment>
            <ListItem disablePadding >
                <ListItemButton onClick={e => setOpen(!open)}>
                    <ListItemIcon>
                        <div style={{ width: 24, height: 24 }}
                            dangerouslySetInnerHTML={{ __html: menu.icone }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Solicitações" />
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {solicitacoes && solicitacoes.map((s =>
                        <Tooltip placement="left-end" title={s.descricao} key={"serv_" + s.nome}>
                            <ListItemButton sx={{ pl: 4 }}
                                onClick={() => handleClickForm(s)}
                            >
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText primary={s.nome} />
                            </ListItemButton>
                        </Tooltip>
                    ))}
                </List>
                {/* <List component="div" disablePadding>
                    {categorias && categorias.map((cat, index) => {
                        if (cat.nome != 'Portal') return
                        return (
                            <div key={"port_" + index}>
                                {cat.servicos.map((serv) => (
                                    <ListItemButton sx={{ pl: 4 }}
                                        key={"serv_" + serv.nome}
                                        onClick={() => handleClickForm(serv)}
                                    >
                                        <ListItemIcon>
                                            <StarBorder />
                                        </ListItemIcon>
                                        <ListItemText primary={serv.nome} />
                                    </ListItemButton>
                                ))}
                            </div>
                        )
                    }
                    )}
                </List> */}
            </Collapse>
        </React.Fragment>
    )
}